<template>
  <a-tree-select
    v-model="value"
    style="width: 100%"
    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
    placeholder="请选择内容"
    :allowClear="allowClear"
    :tree-data="data"
    show-search
    tree-node-filter-prop="title"
    :replaceFields="fieldNames"
    @change="change"
    v-bind="$attrs"
  >
  </a-tree-select>
</template>
<script>
export default {
  name: 'SelectTree',
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    data: {
      type: [Array],
      default: [],
    },
    fieldNames: {
      type: Object,
      default: () => ({
        children: 'children',
        label: 'name',
        value: 'id',
      }),
    },
    allowClear:{
      type:Boolean,
      default:true
    }
  },
  watch: {},
  methods: {
    change(...args) {
      console.log(args, '--args')
      this.$emit('input', args[0])
      this.$emit('change', ...args)
    },
  },
}
</script>
